import { Popup } from '@/ui/overlays/Popup';
import * as React from 'react';
import { createContext, useContext, useState, ReactNode } from 'react';
import clx from 'classnames'
export interface ConfirmOptions {
  title?: string;
  message?: string;
  content?: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  classNamePopupContent?: string
  /** Show only the confirm button — an acknowledgement, not a choice. */
  hideCancel?: boolean;
}

interface ConfirmContextType {
  confirm: (options: ConfirmOptions) => Promise<boolean>;
}

const ConfirmContext = createContext<ConfirmContextType | null>(null);

export const useConfirm = () => {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error('useConfirm must be used inside <ConfirmProvider>');
  return ctx.confirm;
};

export const ConfirmProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [options, setOptions] = useState<ConfirmOptions | null>(null);
  const [resolver, setResolver] = useState<(v: boolean) => void>(() => () => {});

  const confirm = (opts: ConfirmOptions) => {
    setOptions(opts);
    return new Promise<boolean>(resolve => {
      setResolver(() => resolve);
    });
  };

  const close = (result: boolean) => {
    resolver(result);
    setOptions(null);
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}

      {options && (
        <Popup zIndexClassName='tw-z-[1010]' contentClassName={clx('tw-bg-base-100', options.classNamePopupContent || 'tw-w-[600px]')} layer='confirm'>
        {/* <div className="tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-items-center tw-justify-center tw-z-50"> */}
          {/* <div className="tw-bg-white tw-rounded-lg tw-shadow-lg tw-w-[320px] tw-p-5 tw-space-y-4"> */}
            {options.title && (
              <h2 className="tw-text-lg tw-font-semibold tw-text-content-base">
                {options.title}
              </h2>
            )}
            {options.message && (
              <p className="tw-whitespace-pre-line tw-text-sm tw-text-content-base/70">{options.message}</p>
            )}
            {options.content}
            <div className="tw-flex tw-justify-end tw-gap-2 tw-mt-4">
              {!options.hideCancel && (
                <button
                  onClick={() => close(false)}
                  className="tw-bg-base-200 tw-text-content-base tw-rounded-md tw-px-3 tw-py-1 hover:tw-bg-base-300"
                >
                  {options.cancelText ?? 'Anuluj'}
                </button>
              )}
              <button
                onClick={() => close(true)}
                className="tw-bg-blue-600 tw-text-white tw-rounded-md tw-px-3 tw-py-1 hover:tw-bg-blue-700"
              >
                {options.confirmText ?? 'OK'}
              </button>
            </div>
          {/* </div> */}
        {/* </div> */}
        </Popup>
      )}
    </ConfirmContext.Provider>
  );
};
